import {useSelector} from 'react-redux';

/**
 * Whether the current employee's role has resolved. Until it is true, `role` is undefined and any
 * role test that passes on undefined is answering a question it cannot answer.
 * @returns {boolean}
 */
export const useIsKnownEmployee = () => useSelector(state => state.user.isKnownEmployee);
